import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Stack,
    IconButton,
    Alert,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EquipmentService from "../../../services/Equipment.service";
import EditTaggedOutDescriptionDialog from "./EditTaggedOutDescriptionDialog";
import { useAuth } from "../../../contexts/AuthContext";

export default function ResolveTaggedOutModal({ open, onClose, equipment, issue, onResolved }) {
    const { user } = useAuth();
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [openEdit, setOpenEdit] = useState(false);
    const [currentIssue, setCurrentIssue] = useState(issue);

    React.useEffect(() => {
        setCurrentIssue(issue);
    }, [issue]);

    if (!currentIssue) return null;

    const isEditable = currentIssue.created_by_detail?.id === user?.id;

    const handleResolve = async () => {
        setSaving(true);
        setError("");
        try {
            const res = await EquipmentService.updateIssue(currentIssue.id, {
                is_resolved: true,
                resolved_by: user.id,
            });
            onResolved?.(res.data);
            onClose();
        } catch {
            setError("Failed to resolve the issue.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle>Resolve Issue</DialogTitle>
                <DialogContent>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 2 }}>
                        {isEditable && (
                            <IconButton size="small" onClick={() => setOpenEdit(true)}>
                                <EditIcon fontSize="small" color="primary" />
                            </IconButton>
                        )}
                        <Typography variant="body2" color="text.secondary">
                            {currentIssue.description || "No description provided"}
                        </Typography>
                    </Stack>
                    <Typography variant="body2">
                        {`${equipment?.nickname} is tagged out. Would you like to resolve this issue?`}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Not Yet</Button>
                    <Button variant="contained" color="success" disabled={saving} onClick={handleResolve}>
                        {saving ? "Resolving…" : "Resolve"}
                    </Button>
                </DialogActions>
            </Dialog>
            <EditTaggedOutDescriptionDialog
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                issue={currentIssue}
                onUpdated={(updated) => setCurrentIssue(updated)}
            />
        </>
    );
}
